module.exports = Studio.libraries['superagent'];